




import { Component, Mixins } from "vue-property-decorator";
import DoKoSvgImgMixin from "../mixins/DoKoSvgImgMixin.vue";

@Component({ components: {} })
export default class DoKoSymbol extends Mixins(DoKoSvgImgMixin) {
  readonly imgList = "symbol";
}
